export class Controller {
    /** @ngInject */
    constructor($state, Alert, AuthenticationAccessPolicyResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.AuthenticationAccessPolicyResource = AuthenticationAccessPolicyResource;
    }

    assign(app) {
        this.isSaving = app;
        this.AuthenticationAccessPolicyResource.applyPolicy(this.companyId, this.policy.id, app.id)
            .then(() => this.$state.reload('company.policies.authentication-access-policies'))
            .then(() => this.Alert('success', 'company.policies.authentication-access-policies.manage.assigned'))
            .finally(() => (this.isSaving = null));
    }

    unassign(app) {
        this.isSaving = app;
        this.AuthenticationAccessPolicyResource.applyPolicy(this.companyId, this.defaultPolicy.id, app.id)
            .then(() => this.$state.reload('company.policies.authentication-access-policies'))
            .then(() => this.Alert('success', 'company.policies.authentication-access-policies.manage.unassigned'))
            .finally(() => (this.isSaving = null));
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/policies/authentication-access-policies/manage/manage-policy-apps.controller.js